// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CreatePeriodForEmployeeResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/create_period_for_employee
 * Returns the created payroll period with all fields
 *
 * The dados IS the created `payroll_periods` row, emitted flat at the
 * envelope root (not nested under a `period` key). The fields mirror
 * Payroll_PeriodRow one-for-one so the generated runtime schema validates
 * every column. The controller populates them from
 * Payroll_PeriodRow::fromRow() so MySQL-string DECIMAL/date coercion stays
 * in the single Row factory.
 *
 * Money columns (`revenue_conciliation_amount`, `expenses_conciliation_amount`,
 * `total_amount`) are MySQL DECIMAL(10,2) and surface as PHP strings via
 * mysqli — declared as `string` to match runtime, per the project's Typed
 * Data Layer rules.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_CreatePeriodForEmployeeResponseDados {
id: number
franchise_id: number
user_id: string
period_start_date: string
period_end_date: string
revenue_conciliation_amount: string
expenses_conciliation_amount: string
status: number
total_amount: string
created_at: string
updated_at: string
calculated_at?: string
paid_at?: string
paid_by?: string
franchise_name?: string
}

export type Payroll_CreatePeriodForEmployeeResponse = ApiResponse<Payroll_CreatePeriodForEmployeeResponseDados>;

registerResponseContract('Payroll_CreatePeriodForEmployeeResponse', {
  id:                           { type: 'number',  required: true },
  franchise_id:                 { type: 'number',  required: true },
  user_id:                      { type: 'string',  required: true },
  period_start_date:            { type: 'string',  required: true },
  period_end_date:              { type: 'string',  required: true },
  revenue_conciliation_amount:  { type: 'string',  required: true },
  expenses_conciliation_amount: { type: 'string',  required: true },
  status:                       { type: 'number',  required: true },
  total_amount:                 { type: 'string',  required: true },
  created_at:                   { type: 'string',  required: true },
  updated_at:                   { type: 'string',  required: true },
  calculated_at:                { type: 'string',  required: false },
  paid_at:                      { type: 'string',  required: false },
  paid_by:                      { type: 'string',  required: false },
  franchise_name:               { type: 'string',  required: false },
})
